import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'wf-knowledge-base-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.css'],
    standalone: false
})
export class KnowledgeBaseItemComponent implements OnInit {
  @Input() title: string = '' ;
  @Input() description: string | undefined = '' ;
  @Input() thumbnail: string = '' ;

  constructor() { }

  ngOnInit(): void {
  }

}
